module.exports = __webpack_public_path__ + "static/features-drive-0266a15dd9facdb5d88b408c3c83eda2.png";